const initialState = {
    testGroups: {},
    awaitingOptimize: true,
};

export default function gOptimize(state = initialState, action) {
    switch (action.type) {
        case 'SET_TEST_GROUP':
            var testGroups = { ...state.testGroups };
            testGroups[ action.name ] = action.group;
            return {
                ...state,
                testGroups: testGroups,
                awaitingOptimize: false,
            };
        default:
            return state;
    }
}
